import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _SIIFAuxiliaryCatalog, _SIIFAuxiliaryType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SIIFAuxiliaryTypeSelect } from "../SIIFAuxiliaryType/SIIFAuxiliaryTypeSelect";


export const SIIFAuxiliaryCatalog = () => {

    const SIIFAuxiliaryType = useDataBean(_SIIFAuxiliaryCatalog);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [SIIFAuxiliary, setSIIFAuxiliary] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [SIIFAuxiliary])


    const getLista = () => {

        SIIFAuxiliaryType.instance.getSIIFAuxiliaryCatalog(SIIFAuxiliary).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        SIIFAuxiliaryType.setBean({
            IDSIIFAuxiliaryType: SIIFAuxiliaryType.bean.IDSIIFAuxiliaryType
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        SIIFAuxiliaryType.deleteItemVoid(SIIFAuxiliaryType.bean.IDSIIFAuxiliary).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        SIIFAuxiliaryType.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const head = [
        { title: 'ID', property: 'IDSIIFAuxiliary', visible: true },
        { title: 'Tipo de Auxiliar', property: 'SIIFAuxiliaryTypeName', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Mnemonico', property: 'Mnemonic', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Valor SIIF', property: 'SIIFValue', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${SIIFAuxiliaryType.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Catálogo de Auxiliares">
            <div className="row">
                <div className="col-md-6">
                    <SIIFAuxiliaryTypeSelect label='Tipos de Auxiliar' idSelector={SIIFAuxiliary} onChange={(e) => { setSIIFAuxiliary(e) }} />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={SIIFAuxiliaryType.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SIIFAuxiliaryTypeSelect idSelector={SIIFAuxiliaryType.bean.IDSIIFAuxiliaryType} onChange={(e) => { SIIFAuxiliaryType.setBean({ ...SIIFAuxiliaryType.bean, 'IDSIIFAuxiliaryType': e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={SIIFAuxiliaryType.bean.Code} onChange={SIIFAuxiliaryType.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Mnemonico</label>
                                <input type="text" name="Mnemonic" className="form-control" value={SIIFAuxiliaryType.bean.Mnemonic} onChange={SIIFAuxiliaryType.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor SIIF</label>
                                <input type="text" name="SIIFValue" className="form-control" value={SIIFAuxiliaryType.bean.SIIFValue} onChange={SIIFAuxiliaryType.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={SIIFAuxiliaryType.bean.Description} onChange={SIIFAuxiliaryType.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {SIIFAuxiliaryType.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}